import React, { Fragment, useContext, useEffect } from "react";
import { Breadcrumbs, H4, P } from "../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import EntityContext from "./ContextProvider";
import { ContactContext } from "../Contacts/ContextProvider";
import { useNavigate, useParams } from "react-router";
import ContactsTableData from "../Contacts/Presentation/List/ContactsTableData";

export default function EntityProfile() {
  const { id } = useParams();
  const { item, getItem } = useContext(EntityContext);
  const { setFilters, filters } = useContext(ContactContext);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(id);

    if (id) {
      getItem(id);
      setFilters({
        ...filters,
        ...{
          entity_id: id,
        },
      });
    } else {
      navigate(`${process.env.PUBLIC_URL}/app/entities`);
    }
  }, [id]);

  return (
    <Fragment>
      <Breadcrumbs
        title="Detalle de la entidad"
        mainTitle="Detalle de la entidad"
        parent="Entidades"
      />
      <Container fluid Breadcrumbsfluid={true} className="list-products">
        <Row className="list-persons">
          <Col xl="12" md="12">
            <Card className="p-5">
              <CardBody>
                {/* Primera fila: 2 columnas */}
                <Row className="mb-3">
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Nombre de entidad: <span>{item.name}</span>
                      </P>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Tipo de entidad: <span>{item.type}</span>
                      </P>
                    </div>
                  </Col>
                </Row>

                {/* Segunda fila: 4 columnas */}
                <Row className="mb-3">
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Web site URL:{" "}
                        <span>
                          <a target="_blank" href={item?.website_url}>
                            {item?.website_url}
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Whatsapp: <span>{item?.whatsapp}</span>
                      </P>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Facebook URL:{" "}
                        <span>
                          <a target="_blank" href={item?.facebook_url}>
                            {item?.facebook_url}
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Linkedin URL:{" "}
                        <span>
                          <a target="_blank" href={item?.linkedin_url}>
                            {item?.linkedin_url}
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Instagram URL:{" "}
                        <span>
                          <a target="_blank" href={item?.instagram_url}>
                            {item?.instagram_url}
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Usuario de Instagram:{" "}
                        <span>{item.instagram_username}</span>
                      </P>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Twitter URL:{" "}
                        <span>
                          <a target="_blank" href={item?.twitter_url}>
                            {item?.twitter_url}
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Usuario de Twitter: <span>{item.twitter_username}</span>
                      </P>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Provincia:{" "}
                        <span>
                          <a target="_blank" href={item?.twitter_url}>
                            <span>{item?.city?.province?.name}</span>
                          </a>
                        </span>
                      </P>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="bg-gray-200 p-4 rounded-lg ">
                      <P>
                        Ciudad: <span>{item?.city?.name}</span>
                      </P>
                    </div>
                  </Col>
                </Row>

                {/* Cuadro */}
                <Row>
                  <Col md="12">
                    <div className="profile-mail">
                      <div className="email-general">
                        <div className="gender">
                          <div className="bg-gray-200 pb-4 rounded-lg ">
                            <H4>Lista de contactos</H4>
                          </div>
                          {filters?.entity_id != undefined && (
                            <ContactsTableData
                              showDeleteButton={false}
                              showEditButton={false}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
